// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.

// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated

// Shortcuts for editor2
export const EDITOR2_SHORTCUTS = {
	PUBLISH: 'mod+enter',
	PUBLISH_WITH_COMMENT: 'mod+shift+enter',
	EDIT: 'e',
	PREVIEW: 'mod+shift+e',
	UNDO: 'mod+z',
	REDO: 'mod+shift+z',
	FIND_REPLACE: 'mod+f',
};
export const BROWSER_SAVE_SHORTCUT = 'mod+s';
export const COMMENT_EDITOR_SHORTCUT = 'command+enter';
export const INLINE_COMMENTS_SHORTCUT = 'mod+enter';
/** @deprecated Use UNIVERSAL_BLOG_SHORTCUT instead */
export const BLOG_SHORTCUT = 'b';
/** @deprecated Use UNIVERSAL_GLOBAL_CREATE_SHORTCUT_* instead */
export const GLOBAL_CREATE_SHORTCUT = 'c';
/** @deprecated Use UNIVERSAL_STAR_BUTTON_SHORTCUT instead */
export const STAR_BUTTON_SHORTCUT = 'f';
/** @deprecated Use UNIVERSAL_OPEN_COMMENT_EDITOR instead */
export const CREATE_COMMENT_SHORTCUT = 'm';
export const LINK_TO_THIS_PAGE_SHORTCUT = 'k';
export const EDIT_SHORTCUT = 'e';
/** @deprecated Use UNIVERSAL_PRESENTATION_MODE_SHORTCUT or UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI instead */
export const PRESENTATION_MODE_SHORTCUT = 'r';
/** @deprecated Use UNIVERSAL_WATCH_CONTENT_SHORTCUT or UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI instead */
export const WATCH_CONTENT_SHORTCUT = 'w';
/** @deprecated Use UNIVERSAL_SHARE_PAGE_SHORTCUT instead */
export const SHARE_PAGE_SHORTCUT = 's';
/** @deprecated Use UNIVERSAL_LABELS_SHORTCUT instead */
export const LABELS_SHORTCUT = 'l';
/** @deprecated Use UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT instead */
export const VIEW_ATTACHMENTS_SHORTCUT = 't';
/** @deprecated Use UNIVERSAL_NEXT_COMMENT_SHORTCUT instead */
export const NEXT_COMMENT_SHORTCUT = 'n';
/** @deprecated Use UNIVERSAL_PREV_COMMENT_SHORTCUT instead */
export const PREV_COMMENT_SHORTCUT = 'p';
export const SUBMIT_FEEDBACK_SHORTCUT = 'g f';
/** @deprecated Use UNIVERSAL_NAVIGATION_SHORTCUT_* instead */
export const NAVIGATION_SHORTCUT = 'g g';
/** @deprecated Use UNIVERSAL_GO_HOME_SHORTCUT instead */
export const GO_HOME_SHORTCUT = 'g d';
/** @deprecated Use UNIVERSAL_NOTIFICATIONS_SHORTCUT instead */
export const NOTIFICATIONS_SHORTCUT = 'g n';
/** @deprecated Use UNIVERSAL_GO_TO_RECENT_SHORTCUT instead */
export const GO_TO_RECENT_SHORTCUT = 'g r';
/** @deprecated Use UNIVERSAL_GO_TO_STARRED_SHORTCUT instead */
export const GO_TO_STARRED_SHORTCUT = 'g s';
/** @deprecated Use UNIVERSAL_SPACE_OVERVIEW_SHORTCUT instead */
export const SPACE_OVERVIEW_SHORTCUT_NAV_3 = 'g s';
/** @deprecated Use UNIVERSAL_SPACE_OVERVIEW_SHORTCUT instead */
export const SPACE_OVERVIEW_SHORTCUT = 'g o';
/** @deprecated Use UNIVERSAL_AI_MATE_SHORTCUT_* instead */
export const AI_MATE_SHORTCUT = 'g c';
/** @deprecated Use UNIVERSAL_NAVIGATION_SHORTCUT_* instead */
export const NAVIGATION_SLASH_SHORTCUT = '/';
/** @deprecated Use UNIVERSAL_SIDE_NAVIGATION_SHORTCUT instead */
export const SIDE_NAVIGATION_SHORTCUT = '[';
export const UNDO_SHORTCUT = 'mod+z';
export const PREV_TEMPLATE_SHORTCUT = 'left';
export const NEXT_TEMPLATE_SHORTCUT = 'right';
/** @deprecated Use UNIVERSAL_HELP_SHORTCUT instead */
export const HELP_SHORTCUT = '?';
export const AUTOMATION_SHORTCUT = 'a';
/** @deprecated Use UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT instead */
export const TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER = ']';
export const LIVE_PAGE_MODE_SWITCH_TO_EDIT = 'e';
export const LIVE_PAGE_MODE_SWITCH_TO_VIEW = 'mod+shift+e';

//Universal shortcuts used across all page modes
export const UNIVERSAL_NEXT_COMMENT_SHORTCUT = 'ctrl+.';
export const UNIVERSAL_PREV_COMMENT_SHORTCUT = 'ctrl+,';
export const UNIVERSAL_OPEN_COMMENT_EDITOR = 'mod+option+c';
export const UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT = 'ctrl+shift+d';
export const UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT = 'mod+shift+u';
export const UNIVERSAL_PRESENTATION_MODE_SHORTCUT = 'mod+option+r';
export const UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI = 'ctrl+option+r';
export const UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT = 'ctrl+]';
export const UNIVERSAL_BLOG_SHORTCUT = 'mod+option+shift+b';
export const UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC = 'ctrl+option+c';
export const UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN = 'meta+alt+c';
export const UNIVERSAL_HELP_SHORTCUT = 'ctrl+shift+/';
export const UNIVERSAL_SIDE_NAVIGATION_SHORTCUT = 'ctrl+[';
export const UNIVERSAL_STAR_BUTTON_SHORTCUT = 'ctrl+option+f';
export const UNIVERSAL_NOTIFICATIONS_SHORTCUT = 'mod+option+o';
export const UNIVERSAL_NAVIGATION_SHORTCUT_MAC = 'mod+option+q';
export const UNIVERSAL_NAVIGATION_SHORTCUT_WIN = 'meta+alt+q';
export const UNIVERSAL_GO_HOME_SHORTCUT = 'mod+option+h';
export const UNIVERSAL_GO_TO_RECENT_SHORTCUT = 'mod+option+g';
export const UNIVERSAL_GO_TO_STARRED_SHORTCUT = 'mod+option+8';
export const UNIVERSAL_SPACE_OVERVIEW_SHORTCUT = 'mod+option+v';
export const UNIVERSAL_WATCH_CONTENT_SHORTCUT = 'mod+option+w';
export const UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI = 'ctrl+option+w';
export const UNIVERSAL_SHARE_PAGE_SHORTCUT = 'mod+option+s';
export const UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT = 'ctrl+shift+i';
export const UNIVERSAL_LABELS_SHORTCUT = 'ctrl+option+a';
export const UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT = 'mod+option+t';
export const UNIVERSAL_AI_MATE_SHORTCUT_MAC = 'mod+.';
export const UNIVERSAL_AI_MATE_SHORTCUT_WIN = 'meta+.';
